<section class="intro-container">
  <div class="content">
    <h2>{{ titre }}</h2>
    <div class="separator"></div>
    <p>{{ description }}</p>
  </div>
</section>